import * as React from "react";
import Svg, { G, Path, Polygon } from "react-native-svg";

function CartIcon({ size }: { size: number }) {
  return (
    <Svg width={size} height={size} viewBox="0 0 25 22">
      <G id="CC" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <G id="winkelmand-/-selected" transform="translate(-27.000000, -5.000000)">
          <G id="shopping-basket" transform="translate(28.000000, 6.000000)">
            <Polygon
              id="Rectangle"
              fill="#49A241"
              opacity="0.440964472"
              points="1.60477917 10.0000626 19 16.5470388 17.2777852 19.5 4.28590813 19.5"
            />
            <Path
              d="M14.9792947,17.3242656 C15.0164058,17.3304434 15.0532947,17.3334656 15.0896947,17.3334656 C15.4096948,17.3334656 15.6921394,17.1023544 15.746495,16.7762654 L16.4131619,12.7762639 C16.4736952,12.4131082 16.2283618,12.0695969 15.8651617,12.0090636 C15.5019615,11.9483525 15.1584947,12.1938637 15.0979614,12.5570638 L14.4312945,16.5570653 C14.3707611,16.9202655 14.6160945,17.2637767 14.9792947,17.3242656 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
            />
            <Path
              d="M7.05351383,16.7762654 C7.10786941,17.1023544 7.39026952,17.3334656 7.71031408,17.3334656 C7.7467141,17.3334656 7.783603,17.3304879 7.82071413,17.3242656 C8.18391427,17.2637323 8.4292477,16.9202655 8.36871434,16.5570653 L7.70204741,12.5570638 C7.64151406,12.1938637 7.2980917,11.9485747 6.93484712,12.0090636 C6.57164698,12.0695969 6.32631355,12.4130637 6.38684691,12.7762639 L7.05351383,16.7762654 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
            />
            <Path
              d="M22.0888974,6.66666152 L19.7426298,6.66666152 L14.6094723,0.250214605 C14.3795167,-0.0372077277 13.9600054,-0.0839188568 13.6724497,0.146125676 C13.3849385,0.376125765 13.3383163,0.795637038 13.5683608,1.08314826 L18.0351625,6.66666152 L4.72040182,6.66666152 L9.18724799,1.08314826 C9.41724808,0.795637038 9.37062584,0.376081321 9.08315906,0.146125676 C8.79560339,-0.0839188568 8.37609212,-0.0372521721 8.14613648,0.250214605 L3.0129345,6.66666152 L0.666666924,6.66666152 C0.298489004,6.66666152 0,6.96515053 0,7.33332845 L0,10 C0,10.3681741 0.298489004,10.6666631 0.666666924,10.6666631 L1.49715613,10.6666631 L4.02569044,19.5164887 C4.10742381,19.802711 4.36902391,20 4.66666847,20 L18.0888959,20 C18.3865404,20 18.6481405,19.802711 18.7299183,19.5164887 L21.2584082,10.6666631 L22.0888974,10.6666631 C22.4570753,10.6666631 22.7555643,10.3681741 22.7555643,10 L22.7555643,7.33332845 C22.7555643,6.96515053 22.4570753,6.66666152 22.0888974,6.66666152 Z M17.5860512,18.6666631 L5.1695131,18.6666631 L2.88382333,10.6666631 L19.8717854,10.6666631 L17.5860512,18.6666631 Z M21.4222305,9.33332922 C19.1384518,9.33332922 3.49689024,9.33332922 1.33333385,9.33332922 L1.33333385,7.99999537 L21.4222305,7.99999537 L21.4222305,9.33332922 Z"
              id="Shape"
              stroke="#000000"
              fill="#000000"
              fillRule="nonzero"
            />
            <Path
              d="M11.3777822,17.3333323 C11.7459601,17.3333323 12.0444491,17.0348433 12.0444491,16.6666654 L12.0444491,12.6666638 C12.0444491,12.2984859 11.7459601,11.9999969 11.3777822,11.9999969 C11.0096042,11.9999969 10.7111152,12.2984859 10.7111152,12.6666638 L10.7111152,16.6666654 C10.7111152,17.0348877 11.0096042,17.3333323 11.3777822,17.3333323 Z"
              id="Path"
              fill="#000000"
              fillRule="nonzero"
            />
          </G>
        </G>
      </G>
    </Svg>
  );
}
export default CartIcon;
